// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3TpsM","footer":"ModalInfo_footer__2hOsv"};